/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import classname from 'classnames';
import * as React from 'react';

import { IClickableContainerData } from './clickable-container.data';
import { IClickableContainerProps } from './clickable-container.props.autogenerated';

// ==========================================================================
/**
 * ClickableContainer component
 * @extends {React.PureComponent<IClickableContainerProps<IClickableContainerData>>}
 */
// ==========================================================================
class ClickableContainer extends React.PureComponent<IClickableContainerProps<IClickableContainerData>> {

    // =======================================================================
    // PUBLIC METHODS
    // =======================================================================

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element {

        const {
            config: { link, className }
        } = this.props;

        return (
            <a
                className={classname('clickable-container', className)}
                href={link.linkUrl.destinationUrl}
                target={this._target}
                aria-label={link.ariaLabel}
            >
                {this._slots}
            </a>
        );
    }

    // ==========================================================================
    // JSX CONSTRUCTORS
    // ==========================================================================

    // ------------------------------------------------------
    // ------------------------------------------------------
    private get _target(): string | undefined {
        const link = this.props.config.link;
        return (link.openInNewTab) ? '_blank' : undefined;
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private get _slots(): JSX.Element | null {
        const slots = this.props.slots.clickableContent;

        if (slots && slots.length) {
            return (
                <>
                    {slots.map((slot, index) => (
                        <React.Fragment key={index}>
                            {slot}
                        </React.Fragment>
                    ))}
                </>
            );
        }

        // No slots
        return null;
    }
}

export default ClickableContainer;